/**
 * Zod validators for P2P chat user input.
 * @module features/p2p-chat/schemas/p2pChat.schemas
 */

import { z } from 'zod';

export const roomCodeSchema = z
  .string()
  .trim()
  .toLowerCase()
  .min(1)
  .max(60)
  .regex(/^[a-z]+-[a-z]+-[a-z]+$/, {
    message: 'Кодът трябва да е три думи, разделени с тире (silver-fox-delta).',
  });

export const messageInputSchema = z.string().trim().min(1).max(4096);

export type RoomCodeInput = z.infer<typeof roomCodeSchema>;
export type MessageInput = z.infer<typeof messageInputSchema>;
